<template>
    <div class="nearest-items">
        <Spinner :size="nsLoading.options.size" :line-fg-color="nsLoading.options.lineFgColor" v-if="nsLoading.status === true" :message="nsLoading.message" class="pt-2" />
        <observer @on-change="onChange" class="nearest-wrapper">
             <h2 class="text-center mb-2 mb-xl-6" v-if="nsLoading.status === false">{{ text.headline }}</h2>
             <div class="row rows row-s nearest-item-wrapper" v-if="nsLoading.status === false">
                 <div v-for="item in nearestMarker" :key="item.id"
                  class="store store-container col-12 col-lg-4">
                    <nearest :item="item"></nearest>
                 </div>
             </div>
        </observer>
    </div>
</template>

<script>
import Nearest from '@/components/Nearest'
import { mapState } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import Spinner from 'vue-simple-spinner'
import Observer from 'vue-intersection-observer'
import ServiceDrupal from '@/services/ServiceDrupal.js'

export default {
    name: 'nearest-stores',
    data () {
        return {
            count: 0,
            nearestMarker: [],
            nsLoading: {
                status: true,
                message: Drupal.t('Find stores near by'),
                lunched: false,
                options: {
                    size: 'huge',
                    lineFgColor: '#ffea69'
                }
            },
            text: {
                headline: Drupal.t('Stores near by')
            }
        }
    },
    props: {
        store: {
            type: Object,
            default: null
        }
    },
    components: {
        Nearest,
        Spinner,
        Observer
    },
    watch: {
        completed: function (value) {
            if (value) {
                this.$store.dispatch('store/fetchNearest', {
                    position: this.store.geolocation,
                    google: this.google
                })
                this.nsLoading.status = false
            }
        },
        markers: function () {
            let localThis = this
            this.markers.forEach(marker => {
                if (marker.id !== localThis.store.id && localThis.count < 3 && marker.status === '1') {
                    localThis.count++
                    localThis.nearestMarker.push(marker)
                }
            })
        }
    },
    computed: {
        ...mapState({
            markers: state => state.store.markers
        }),
        google: gmapApi,
        completed () {
            return this.google !== null && this.nsLoading.lunched !== false && this.store
        }
    },
    methods: {
        onChange (entry, unobserve) {
            // After loading Cancel monitoring, optimise performance
            if (entry.isIntersecting) {
                unobserve()
            }
            if (entry.isIntersecting === true) {
                this.nsLoading.lunched = true
            }
        }
    },
    beforeMount () {
        this.nsLoading.status = true
    }
}
</script>
